export async function claimPairingCode(input) {
    const deviceCode = await input.credentials.getOrCreateDeviceCode();
    const response = await input.api.claimPairing({
        code: input.code.trim().toUpperCase(),
        deviceCode,
        appVersion: input.appVersion,
        platform: input.identity.platform,
        playerBuild: input.identity.playerBuild,
        capabilities: input.identity.capabilities,
        ...(input.identity.manufacturer
            ? { manufacturer: input.identity.manufacturer }
            : {}),
        ...(input.identity.model ? { model: input.identity.model } : {}),
    });
    await input.credentials.set({
        deviceId: response.deviceId,
        token: response.token,
        screenId: response.screenId,
    });
    return response;
}
//# sourceMappingURL=claim.js.map